import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  headCountDetailsList: { loading: false, data: null, error: null },
  locationAreaDetails: { loading: false, data: null, error: null },
};

export const headCountDetailsSlice = createSlice({
  name: "headCountDetails",
  initialState,
  reducers: {
    fetchHeadCountDetailsListRequest: (state, action) => {
      state.headCountDetailsList.loading = true;
      state.headCountDetailsList.error = null;
    },
    fetchHeadCountDetailsListSuccess: (state, action) => {
      state.headCountDetailsList.data = action.payload;
      state.headCountDetailsList.loading = false;
      state.headCountDetailsList.error = null;
    },
    fetchHeadCountDetailsListFailure: (state, action) => {
      state.headCountDetailsList.data = null;
      state.headCountDetailsList.loading = false;
      state.headCountDetailsList.error = action.payload;
    },
    updateLocationAreaDetailsRequest: (state, action) => {
      state.locationAreaDetails.loading = true;
      state.locationAreaDetails.error = null;
    },
    updateLocationAreaDetailsSuccess: (state, action) => {
      state.locationAreaDetails.data = action.payload;
      state.locationAreaDetails.loading = false;
      state.locationAreaDetails.error = null;
    },
    updateLocationAreaDetailsFaliure: (state, action) => {
      state.locationAreaDetails.data = null;
      state.locationAreaDetails.loading = false;
      state.locationAreaDetails.error = action.payload;
    },
  },
});

export const {
  fetchHeadCountDetailsListRequest,
  fetchHeadCountDetailsListSuccess,
  fetchHeadCountDetailsListFailure,
  updateLocationAreaDetailsRequest,
  updateLocationAreaDetailsSuccess,
  updateLocationAreaDetailsFaliure,
} = headCountDetailsSlice.actions;

export const getheadCountDetailsListState = (store) =>
  store.headCountDetails?.headCountDetailsList;

export const getUpdateLocationAreaDetailsState = (store) =>
  store.headCountDetails?.locationAreaDetails;

export default headCountDetailsSlice.reducer;
